import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Twitter, Sparkles } from 'lucide-react';
import { playSoundIfEnabled } from '../utils/sounds';

const Footer = () => {
  const handleClick = () => {
    playSoundIfEnabled('click');
  };

  return (
    <footer className="bg-black text-white py-12 lg:py-16 border-t border-light-pink/20">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Sparkles className="w-8 h-8 text-light-pink" />
              <div>
                <h3 className="text-xl font-display font-bold text-light-pink leading-none">
                  INSPIRE STUDIO
                </h3>
                <p className="text-xs text-light-pink/70 font-mono uppercase tracking-wider">
                  Oxford
                </p>
              </div>
            </div>
            <p className="text-sm text-mid-grey leading-relaxed">
              Where young actors discover their stage through the magic of Shakespeare and drama.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-light-pink font-semibold mb-4 text-lg">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link 
                to="/" 
                className="text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm"
                onClick={handleClick}
              >
                Home
              </Link>
              <Link 
                to="/workshops" 
                className="text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm"
                onClick={handleClick}
              >
                Workshops
              </Link>
              <Link 
                to="/gallery" 
                className="text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm"
                onClick={handleClick}
              >
                Gallery
              </Link>
              <Link 
                to="/about" 
                className="text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm"
                onClick={handleClick}
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm"
                onClick={handleClick}
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-light-pink font-semibold mb-4 text-lg">Get In Touch</h4>
            <div className="flex flex-col gap-3">
              <a 
                href="mailto:williamrichard74@gmail.com" 
                className="flex items-center gap-2 text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm group"
                onClick={handleClick}
              >
                <Mail className="w-4 h-4 group-hover:scale-110 transition-transform" />
                <span>williamrichard74@gmail.com</span>
              </a>
              <a 
                href="tel:07511662530" 
                className="flex items-center gap-2 text-mid-grey hover:text-light-pink transition-colors duration-200 text-sm group"
                onClick={handleClick}
              >
                <Phone className="w-4 h-4 group-hover:scale-110 transition-transform" />
                <span>07511662530</span>
              </a>
              <div className="flex items-center gap-2 text-mid-grey text-sm">
                <MapPin className="w-4 h-4" />
                <span>Oxford, UK</span>
              </div>
            </div>
          </div>

          {/* Social & Newsletter */}
          <div>
            <h4 className="text-light-pink font-semibold mb-4 text-lg">Follow Us</h4>
            <div className="flex gap-3 mb-6">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-light-pink/10 hover:bg-light-pink/20 text-light-pink transition-all duration-200 hover:scale-110"
                onClick={handleClick}
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-light-pink/10 hover:bg-light-pink/20 text-light-pink transition-all duration-200 hover:scale-110"
                onClick={handleClick}
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-light-pink/10 hover:bg-light-pink/20 text-light-pink transition-all duration-200 hover:scale-110"
                onClick={handleClick}
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-mid-grey">
              Stay updated with our latest workshops and theatre news!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-light-pink/20 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-mid-grey">
            © 2026 INSPIRE STUDIO OXFORD. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-mid-grey">
            <Link 
              to="/privacy" 
              className="hover:text-light-pink transition-colors duration-200"
              onClick={handleClick}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="hover:text-light-pink transition-colors duration-200"
              onClick={handleClick}
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
